import { createSlice } from '@reduxjs/toolkit';
import { AppThunk } from '../../../../app/store';
import { validateMIBCodesEndPoint } from '../../../../common/api.endPoints';
import { HttpService } from '../../../../common/http.service';

export const codebackSlice = createSlice({
  name: 'codeback',

  initialState: {
    codes: {},
    validationResult: {},
    validationError: '',
    validationFailed: false,
  },

  reducers: {
    onCodebackValidation: (state, action) => {
      state.validationResult = action.payload;
      state.validationFailed = false;
    },
    onCodebackValidationFailed: (state, action) => {
      state.validationResult = {};
      state.validationError = action.payload?.message;
      state.validationFailed = true;
    },
  },
});

export const validateMIBCodes =
  (applicationId: string, codes: string[]): AppThunk =>
  async dispatch => {
    const response = await HttpService.getInstance().post(
      validateMIBCodesEndPoint(applicationId),
      { codes },
    );
    if (response && !response.error) {
      const validationResult = response.parsedBody;
      dispatch(codebackActions.onCodebackValidation({ validationResult }));
    } else {
      dispatch(codebackActions.onCodebackValidationFailed(response?.error));
    }
  };

export const codebackReducer = codebackSlice.reducer;
export const codebackActions = codebackSlice.actions;
